module.exports = __webpack_public_path__ + "static/media/female-avatar-portrait.5424a5c2.png";